<div class="Loading" *ngIf="isShowLoading==true">
    <div class="loader"></div>
    <label class="loaderlabel">Please wait while Processing....</label>
</div>


<div class="row">
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: -25px;margin-bottom: 20px;">

		<p class="headding">{{'Submit a Claim'|translate}}</p>
		<ul *ngIf="this.ObjClaimAddReq.ProductCode!=''"
			style="list-style-type: none; padding: 0px;display: flex;justify-content: flex-end;">
			<li><button (click)="Clear()" class="MiddleButton" style="width: 140px;">
					<span></span>
					<span></span>
					<span></span>
					<span></span>{{'Back' | translate}}</button></li>
		</ul>
	
	
		<!-- <ul class="nav nav-tabs listdata" role="tablist">
			<li role="presentation" class="active">
				<a href="#home" class="header" aria-controls="home" role="tab" data-toggle="tab">{{'Submit a Claim' |
					translate }}</a>
			</li>
		</ul> -->
	
		<form #SubmitClaimForm="ngForm">
	
			<div class="row" *ngIf="this.ObjClaimAddReq.ProductCode==''">
				<!-- Left Card  -->
				<div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" (click)="SetProduct('5515')">
					<div class=" panel-default bordercard center-label " style="margin-top: 30px;">
						<a class="third after">{{'Third-Party Motor Claim'|translate}}</a>
					</div>
				</div>
				<!-- Left Card end  -->
	
				<!-- Right Card  -->
				<div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" (click)="SetProduct('5520')">
					<div class=" panel-default bordercard center-label " style="margin-top: 30px;">
						<a class="third after">{{'Comprehensive Motor Claim'|translate}}</a>
					</div>
				</div>
				<!-- Right Card end  -->
	
			</div>
	
	
	
			<div class="row" *ngIf="this.ObjClaimAddReq.ProductCode!=''">
				<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 ">
					<p class="para1">{{'Please submit your insurance claim by completing the form below:' |translate }}</p>
				</div>
	
	
				<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 bordercardForm bordercard">
					<div class="row">
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'The Party Who Registered the Accident'|translate}}</label>
								<select class="form-control" [(ngModel)]="ObjClaimAddReq.ClaimTypeCode"
									(ngModelChange)="ClaimChange(ObjClaimAddReq.ClaimTypeCode)" name="ClaimTypeCode"
									#ClaimTypeCode="ngModel" required>
									<option value="">{{'Select'| translate}}</option>
									<option *ngFor="let ClaimType of objBindInfoRes.ClaimTypeList"
										[value]="ClaimType.ClaimTypeCode">
										{{Lang=="en"?ClaimType.ClaimTypeDesc_En:ClaimType.ClaimTypeDesc_Ar}}
									</option>
								</select>
								<span class="text-danger valid"
									*ngIf="ClaimTypeCode.errors && (ClaimTypeCode.dirty || ClaimTypeCode.touched || IsSubmitted)">
									<p *ngIf="ClaimTypeCode.errors.required">
										{{'ClaimType Code is required'|translate}}</p>
								</span>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'First Name'|translate}}</label>
								<input type="text" class="form-control" name="firstName" #firstName="ngModel"
									[(ngModel)]="ObjClaimAddReq.FirstName" (keypress)="validText($event)" required>
								<span class="text-danger valid"
									*ngIf="firstName.errors && (firstName.dirty || firstName.touched || IsSubmitted)">
									<p *ngIf="firstName.errors.required">
										{{'First Name is required'|translate}}</p>
								</span>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'Last Name'|translate}}</label>
								<input type="text" class="form-control" name="lastName" #lastName="ngModel"
									[(ngModel)]="ObjClaimAddReq.LastName" (keypress)="validText($event)">
								<span class="text-danger valid"
									*ngIf="lastName.errors && (lastName.dirty || lastName.touched || IsSubmitted)">
									<p *ngIf="lastName.errors.required">
										{{'Last Name is required'|translate}}</p>
								</span>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'Mobile Number'|translate}}</label>
								<input type="text" class="form-control" name="mblNum" pattern="^[5][0-9]*$"
									#mblNum="ngModel" (keypress)="validNumber($event)"
									[(ngModel)]="ObjClaimAddReq.MobileNumber" required maxlength="9" minlength="9">
								<span class="text-danger valid"
									*ngIf="mblNum.errors && (mblNum.dirty || mblNum.touched || IsSubmitted)">
									<p *ngIf="mblNum.errors.required">
										{{'Mobile No is required'|translate}}</p>
									<p *ngIf="mblNum.errors.pattern">{{'Mobile Number must be like (5XXXXXXXX)'|translate}}
									</p>
									<p *ngIf="mblNum.errors.minlength">{{'Mobile Number must be 9 digits'|translate}} </p>
									<p *ngIf="mblNum.errors.maxlength">{{'Mobile Number must be 9 digits'|translate}} </p>
								</span>
							</div>
						</div>
	
	
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'Email'|translate}}</label>
								<input type="text" class="form-control" name="email" [(ngModel)]="ObjClaimAddReq.Email"
									#email="ngModel" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" required>
								<span class="text-danger valid"
									*ngIf="email.errors && (email.dirty || email.touched || IsSubmitted)">
									<p *ngIf="email.errors.required">
										{{'Email is required'|translate}}</p>
									<p class="text-danger valid" [hidden]="!email.hasError('pattern')">
										{{ "Invalid Email Format"| translate}}
									</p>
								</span>
							</div>
						</div>


						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'Sequence Number'|translate}}</label>
								<input class="form-control"  type="text" id="txtSeqNo" name="txtSeqNo" [(ngModel)]="ObjClaimAddReq.SequenceNo" #txtSeqNo="ngModel" numbersOnly minlength="4" maxlength="9" required pattern="^[0-9][0-9]{5,8}$">
								<span *ngIf="txtSeqNo.errors && (txtSeqNo.dirty || txtSeqNo.touched || IsSubmitted)" class="text-danger valid">
									<p *ngIf="txtSeqNo.errors?.required">
										{{'Sequence No is required'| translate }}</p>
									<p *ngIf="txtSeqNo.errors?.pattern && txtSeqNo.invalid && txtSeqNo.touched">
										{{'Sequence No must be 4 to 9 digits' | translate }} </p>
								</span>
							</div>
						</div>


					</div>
	
				</div>
	
				<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12">
					<p class="para">{{'Information of the affected person' |translate }}</p>
				</div>
	
	
				<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 bordercardForm bordercard">
					<div class="row">
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'Policy Number'|translate}}</label>
								<input type="text" class="form-control" name="txtPolicyNumber" #txtPolicyNumber="ngModel"
									[(ngModel)]="ObjClaimAddReq.PolicyNo" required>
								<span class="text-danger valid"
									*ngIf="txtPolicyNumber.errors && (txtPolicyNumber.dirty || txtPolicyNumber.touched || IsSubmitted)">
									<p *ngIf="txtPolicyNumber.errors.required">
										{{'Policy Number is required'|translate}}</p>
								</span>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'Accident Date'|translate}}</label>
								<input type="date" class="form-control" name="txtAccidentDate" #txtAccidentDate="ngModel"
									[(ngModel)]="ObjClaimAddReq.AccidentDate" required>
								<span class="text-danger valid"
									*ngIf="txtAccidentDate.errors && (txtAccidentDate.dirty || txtAccidentDate.touched || IsSubmitted)">
									<p *ngIf="txtAccidentDate.errors.required">
										{{'AccidentDate is required'|translate}}</p>
								</span>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'Plate Number'|translate}}</label>
								<input type="text" class="form-control" name="plateNum" #plateNum="ngModel"
									[(ngModel)]="ObjClaimAddReq.PlateNumber" minlength="2" maxlength="10" required>
								<span class="text-danger valid"
									*ngIf="plateNum.errors && (plateNum.dirty || plateNum.touched || IsSubmitted)">
									<p *ngIf="plateNum.errors.required">
										{{'Plate Number is required'|translate}}</p>
									<p class="text-danger valid" *ngIf="plateNum.hasError('minlength')">
										{{ 'Plate Number must be atleast 2 digits' | translate }}
									</p>
								</span>
							</div>
						</div>
	
	
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'ID number'|translate}}</label>
								<input class="form-control" type="tel" required maxlength="10" minlength="10"
									name="IDNumber" [(ngModel)]="ObjClaimAddReq.IDNumber" #IDNumber="ngModel"
									pattern="^[1,2,7][0-9]*" autocomplete="off">
								<span class="text-danger valid"
									*ngIf="IDNumber.errors && (IDNumber.dirty || IDNumber.touched || IsSubmitted)">
									<p *ngIf="IDNumber.errors.required">
										{{'ID number is required'|translate}}</p>
									<p *ngIf="IDNumber.errors?.pattern">
										{{'ID Number Must start with 1 or 2 or 7 and must be 10 digits'|translate}}</p>
									<p *ngIf="IDNumber.errors?.maxlength && !IDNumber.errors?.pattern">{{'Id Number Must must be 10 digits'|translate}}
									</p>
									<p *ngIf="IDNumber.errors?.minlength && !IDNumber.errors?.pattern">{{'Id Number Must must be 10 digits'|translate}}
									</p>
								</span>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="ItemHolder">
								<label>{{'IBAN Number'|translate}}</label>
								<input type="text" class="form-control" name="ibanNum" #ibanNum="ngModel"
									pattern="^SA[0-9]*$" [(ngModel)]="ObjClaimAddReq.IbanNo" minlength="24" maxlength="24"
									required>
								<span class="text-danger valid"
									*ngIf="ibanNum.errors && (ibanNum.dirty || ibanNum.touched || IsSubmitted)">
									<p *ngIf="ibanNum.errors.required">
										{{'IBAN Number is required'|translate}}</p>
									<p class="text-danger valid" *ngIf="ibanNum.hasError('pattern')">
										{{ 'IBAN Number starts with SA(Capital letters only)' | translate }}
									</p>
									<p class="text-danger valid" *ngIf="ibanNum.hasError('minlength') && !ibanNum.hasError('pattern')">
										{{ 'IBAN Number must be 24 digits' | translate }}
									</p>
								</span>
							</div>
						</div>
	
						<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" *ngIf="Najm">
							<div class="ItemHolder">
								<label>{{'Najm Status Number'|translate}}</label>
								<input type="text" class="form-control" name="NajmSNum" #NajmSNum="ngModel"
									[(ngModel)]="ObjClaimAddReq.NajmId" minlength="10" maxlength="10" required>
								<span class="text-danger valid"
									*ngIf="NajmSNum.errors && (NajmSNum.dirty || NajmSNum.touched || IsSubmitted)">
									<p *ngIf="NajmSNum.errors.required">
										{{'Najm Status Number is required'|translate}}</p>
									<p class="text-danger valid" *ngIf="NajmSNum.hasError('minlength')">
										{{ 'Najm Status Number must be 10 digits' | translate }}
									</p>
								</span>
							</div>
						</div>
					</div>
	
				</div>
	
				<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 " *ngIf="ObjClaimAddReq.ProductCode=='5515'">
					<p class="para">{{'Third-party customers are required to attach the following:' |translate }}</p>
				</div>
				<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 " *ngIf="ObjClaimAddReq.ProductCode=='5520'">
					<p class="para">{{'Comprehensive insurance customers are required to attach the following:' |translate
						}}</p>
				</div>
				<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 ">
					<a style="cursor:pointer;text-decoration: underline;" (click)="DownloadClaimForm()">{{'Click here to download the PDF to fill it and Click'| translate}}</a>
				</div>
	
	
	
	
				<div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" style="padding: 10px 10px;"
					*ngFor="let ClaimAttachment of FilterClaimAttachment(objBindInfoRes.ClaimAttachmentList)">
					<div style="min-height: 180px;border: 2px solid #1649a7;border-radius: 12px;padding: 5px;">
						<div style="display: flex; width: fit-content;">
							<span *ngIf="ClaimAttachment.IsMandatory==true"
								style="color: red; font-weight: bold; font-size: 20px;">*</span>
							<label class="flbl">{{Lang=='en'?ClaimAttachment.AttachmentDesc:ClaimAttachment.AttachmentDescAr}}</label>
						</div>
	
						<div class="uploadImgBtn">
							<p style="margin: 0px;z-index: -1;">{{'Upload Image'|translate}}</p>
							<span class="material-icons" style="z-index: -1;color: green;"><i
									class="fa fa-image"></i></span>
						</div>
						<div style="z-index: 1;position:relative;opacity: 0;">
							<input type="file" placeholder="File" id="file" multiple
								accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
								(change)="OnFileUpload($event,ClaimAttachment.AttachmentShortDesc)" name="file">
	
						</div>
	
	
	
						<div style="margin-top: 5px;"
							*ngIf="ClaimAttachment.ImageList!=null && ClaimAttachment.ImageList.length>0">
							<div *ngFor="let i of ImageRows(ClaimAttachment.ImageList)">
								<div *ngFor="let objImg of ClaimAttachment.ImageList | slice:(i*2):(i+1)*2  let i=index"
									width-50>
									<span aria-hidden="true" name="close" style="color: red;zoom: 1.5;"
										(click)="Removefile(ClaimAttachment.AttachmentShortDesc,i)">×</span>
									<img style="width: 53px;height: 53px;;" src="{{objImg.Attachment}}" alt="">
								</div>
							</div>
						</div>
	
						<!-- <small class="fsmall">{{'Max. file size: 5mb. File format:JPG'|translate}}</small> -->
	
					</div>
	
				</div>
	
				<div style="width: 100%; display: flex; justify-content: center; margin-bottom: 20px;">
					<ul style="list-style-type: none; padding: 0px;">
						<li><button (click)="SubmitClaim(SubmitClaimForm)" class="MiddleButton" style="width: 140px;">
								<span></span>
								<span></span>
								<span></span>
								<span></span>{{'Submit' | translate}}</button></li>
					</ul>
				</div>
	
			</div>
	
	
	
		</form>
	
	</div>
</div>


<div class="tab-content ProposalPage" *ngIf="this.ObjClaimAddReq.ProductCode==''">

	<div role="tabpanel" class="tab-pane active" id="home">

		<div class="row">
			<div class="col-md-12 proposals">

				<div class="panel panel-default panel-table">
					<div class="panel-heading">
								<h3 class="panel-title"> {{'Claims List'|translate}}</h3>

					</div>
					<div class="panel-body">
						<table class="table table-striped table-bordered table-list">
							<thead>
								<tr>
									<th>{{'Claim Intimation No'|translate}}</th>
									<th>{{'Claim Type'| translate }}</th>
									<th>{{'Policy No'|translate}}</th>
									<th>{{'Name'| translate }}</th>
									<th>{{'Email'| translate }}</th>
									<th>{{'Mobile No'|translate}}</th>
									<th>{{'Actions'|translate}}</th>

								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let obj of ObjGetClaimsRes">
									<td style="color: red;">{{obj.ClaimIntimationNo}}</td>
									<td>{{obj.ClaimTypeDesc_En}}</td>
									<td>{{obj.PolicyNo}}</td>
									<td>{{obj.FirstName}} {{obj.LastName}}</td>
									<td>{{obj.Email}}</td>
									<td>{{obj.MobileNumber}}</td>
									<td class="ActionBtnList"><button (click)="GetCalimStatus(obj)" style="color: #1649a7;">Status</button><i
											class="fa fa-eye fa-lg action" (click)="ViewClaim(obj)"></i></td>
								</tr>
							</tbody>
						</table>

					</div>

				</div>

			</div>
		</div>

	</div>
</div>



<!-- Claim status Start -->
<div class="overlay" *ngIf="ShowClaimStatus" >
	<div class="popup">
	  <div class="modalcard">
		<p class="modaltitle">{{'Claim Status'|translate}}
			<span style="color: aliceblue;font-weight: 500;cursor: pointer;" (click)="HideClaimStatus()">X</span>
		</p>

		
		<div class="cardcontent" style="width: 100%;">
			
			<div class="wrapper" *ngIf="Lang=='en'">
			  <ul class="StepProgressEnglish">
				<li class="StepProgressEnglish-item is-done" *ngFor="let obj of ClaimStatusRes.ClaimStatusList">
				  <strong>{{obj.Status}}</strong>
				  {{obj.StatusDesc}}
				</li>
			  </ul>
			</div>
  
			<div class="wrapper" *ngIf="Lang=='ar'">
			  <ul class="StepProgressArabic">
				<li class="StepProgressArabic-item is-done" *ngFor="let obj of ClaimStatusRes.ClaimStatusList">
					<strong>{{obj.Status}}</strong>
					{{obj.StatusDesc}}
				</li>
			  </ul>
			</div>
		
		</div>

	  </div>
	</div>
</div>
<!-- Claim status end -->


<!-- Claim details start -->
<div class="row">
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 overlay" *ngIf="ClaimDetailsModal">
		<div class="popup">
			<div class="modalcard">
				<p class="modaltitle">{{'Details'|translate}}
					<span name="close" style="color: white;font-weight: 500;cursor: pointer;" (click)="HideClaimDetailsModal()">X</span>
				</p>
	
	
				<div class="cardcontent">
					<div class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 Align" >
							<label class="customlabel">{{'ID Number'|translate}}</label>
							<input [(ngModel)]="ClaimDetails.IDNumber" disabled>
	
						</div>
					</div>
					<div class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 Align">
							<label class="customlabel">{{'Mobile No'|translate}}</label>
							<input [(ngModel)]="ClaimDetails.MobileNumber"
								disabled>
	
						</div>
					</div>
					<div class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 Align" >
							<label class="customlabel">{{'First Name' | translate }}</label>
							<input [(ngModel)]="ClaimDetails.FirstName"
								disabled>
	
						</div>
					</div>
					<div class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 Align">
							<label class="customlabel">{{'Email' | translate }}</label>
							<input [(ngModel)]="ClaimDetails.Email" disabled>
	
						</div>
					</div>
					<div class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 Align">
							<label class="customlabel">{{'Plate Number'|translate}}</label>
							<input [(ngModel)]="ClaimDetails.PlateNumber"
								disabled>
	
						</div>
					</div>
					<div class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 Align">
							<label class="customlabel">{{'Accident Date'|translate}}</label>
							<input [(ngModel)]="ClaimDetails.AccidentDate"
								disabled>
	
						</div>
					</div>
					<div class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 Align">
							<label class="customlabel">{{'IBAN Number'|translate}}</label>
							<input [(ngModel)]="ClaimDetails.IbanNo" disabled>
	
						</div>
					</div>


					<div *ngIf="ClaimDetails.Attachments.length!=0" class="row" style="padding:15px 0 0 0;">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div style="width:100%;">
								<label class="customlabel">{{'Attachments :' | translate }}</label>
							  </div>
							  <div style="margin-top: 10px;">
								<div class="row">
								  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="padding: 5px;" *ngFor="let item of ClaimDetails.Attachments" >
									<img (click)="DownloadAttchments(item)" class="navlogo" style="border: 1px solid #428bca;width: 110px;height: 100px;"
									  src="{{item.Attachment}}" download="claimImages">
								</div>
							  </div>
							  </div>
						</div>
						
					</div>
						
				</div>
				
			</div>
		</div>	
	</div>
</div>
<!-- Claim details end -->






// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/ClaimsIntimation/ClaimsIntimation.html